import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { apiReset } from "../../store/actions";
import { ApiStatusEnum } from "../../store/api/reducers";
import { RootState } from '../../store/reducers';

export const ApiResponseToast = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {status, message, error} = useSelector((state:RootState) => state.ApiStatus);

    useEffect(() => {
        toastr.options = {
            positionClass: "toast-custom-position",
            onHidden: () => resetApiStatus()
        }
        
        if (status === ApiStatusEnum.Success) {
            toastr.success(t(message || "") || t('Success'));

        } else if (status === ApiStatusEnum.Error) {
            toastr.error(t(error || "") || t('Error'));

        }else if (status === ApiStatusEnum.Info) {
            toastr.info(t(message || "") || t('Info'));

        } else if (status === ApiStatusEnum.Loading) {
            toastr.info(t(message || "") || t('Loading'));

        }
    },[status]) // eslint-disable-line react-hooks/exhaustive-deps

    const resetApiStatus = () => {
        dispatch(apiReset());
    }

    return <></>;
}